<template>
  <row12>
    <edit-multi-label-dialog @select_label_ids=select_label_ids @update_label="update_label" :labels="labels" :selected_labels_ids="selected_labels_ids" @close_modal="close_modal" v-if="multi_edit_dialog"></edit-multi-label-dialog>
    <v-overlay v-if="loading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <row v-if="show_select">
      <col12 style="text-align:right">
        <h4>{{$t('set_label_sets.selected_labels')}}</h4>
        <v-chip v-for="label in selected_labels" :key="label.id" close @click:close="() => unselect_label(label.id)"
                :dark="true" small
                :style="{ 'font-weight': 'bold', 'background-color': `rgba(${label.color})` }">
          {{ label.name }}
        </v-chip>
      </col12>
    </row>

    <div>
      <v-btn small color="primary" @click.native="viewmodus='tree'">
        <v-icon x-small>
          fas fa-sitemap
        </v-icon>
        <span style="padding-left: 10px;">{{$t('set_labels.tree_view')}}</span>
      </v-btn>
      <v-btn small color="primary" @click.native="viewmodus='list'">
        <v-icon x-small>
          fas fa-th-list
        </v-icon>
        <span style="padding-left: 10px;">{{$t('set_labels.list_view')}}</span>
      </v-btn>
    </div>
    <my-boxes-modal :label_name="boxes_modal_label_name" v-if="show_boxes_modal" @close_modal="close_preview_label_in_modal"></my-boxes-modal>
    <list-view v-if="viewmodus==='list'" :show_select="true" :labels="labels"
               :selected_labels_ids="selected_labels_ids"
               @select_label_ids="select_label_ids"
               @unselect_label="unselect_label"
               @update_label="update_label"
               @preview_label="preview_label_in_modal"
               :menu_items_on_select="menu_items_on_select"
                ></list-view>
    <tree-view v-if="viewmodus==='tree'"
               :show_select="show_select" :labels="labels"
               :selected_labels_ids="selected_labels_ids"
               @unselect_label="unselect_label"
               @select_label_ids="select_label_ids"
               @preview_label="preview_label_in_modal"
               ></tree-view>
  </row12>
</template>

<script>
import Row12 from "@/components/layout/Row12";
import ListView from "@/components/manage_labels/ListView";
import TreeView from "@/components/manage_labels/TreeView";
import LoadLabelsMixin from "@/mixins/LoadLabelsMixin";
import MyBoxesModal from "@/components/MyBoxesModal";
import Row from "@/components/layout/Row.vue";
import Col12 from "@/components/layout/Col12.vue";
import EditMultiLabelDialog from "@/components/manage_labels/EditMultiLabelDialog.vue";


export default {
  name: "LabelList",
  data() {
    return {
      'viewmodus': 'list', //or list
      'show_boxes_modal': false,
      'boxes_modal_label_name': false,
      'multi_edit_dialog': false,
      'force_label_reload': true,
    }
  },
  props: {
    selected_labels_ids: {default: () => []},
    show_select: {default: false},
  },
  mixins: [LoadLabelsMixin],
  methods: {
    close_modal() {
      this.$set(this, 'multi_edit_dialog', false)
    },
    open_multi_edit_modal() {
      this.$set(this, 'multi_edit_dialog', true)
    },
    select_label_ids (ids) {
      this.$emit('select_label_ids', ids)
    },
    unselect_label(label_id) {
      let updated_selected_label_ids = this.selected_labels_ids.filter(id => id != label_id);
      this.$emit('select_label_ids', updated_selected_label_ids)
    },
    preview_label_in_modal(label_name) {
      this.$set(this, 'show_boxes_modal', true);
      this.$set(this, 'boxes_modal_label_name', label_name);
    },
    close_preview_label_in_modal() {
      this.$set(this, 'show_boxes_modal', false);
      this.$set(this, 'boxes_modal_label_name', null);
    },
    update_label(label) {
      this.$store.dispatch('label/patch', { item: label, dispatch: this.$store.dispatch })
    }
  },
  computed: {
    selected_labels() {
      // Use Set for O(1) lookup instead of includes which is O(n)
      const selectedSet = new Set(this.selected_labels_ids);
      return this.labels.filter(label => selectedSet.has(label.id));
    },
    menu_items_on_select() {
      return [
        {'title': this.$t('set_labels.edit_selected_labels'), 'on_click': this.open_multi_edit_modal},
      ]
    },
    loading() {
      return this.labels_loading
    }
  },
  mounted () {
  },
  components: {EditMultiLabelDialog, Col12, Row, MyBoxesModal, TreeView, ListView, Row12},
}
</script>

<style scoped>

</style>